/**
 * @description cookie操作类
 * @author aprilcai
 * @docs https://developer.mozilla.org/zh-CN/docs/Web/API/Document/cookie
 */

const getExpires = (vEnd: number | string | Date) => {
  const isInfinity = vEnd === Infinity;
  switch (vEnd.constructor) {
    case Number:
      return isInfinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : `; max-age=${vEnd}`;
    case String:
      return `; expires=${vEnd}`;
    case Date:
      return `; expires=${(vEnd as Date).toUTCString()}`;
  }
};

export const cookies = {
  getItem(sKey: string) {
    return (
      decodeURIComponent(document.cookie.replace(
        new RegExp(`(?:(?:^|.*;)\\s*${encodeURIComponent(sKey).replace(
          /[-.+*]/g,
          '\\$&',
        )}\\s*\\=\\s*([^;]*).*$)|^.*$`),
        '$1',
      )) || null
    );
  },

  // eslint-disable-next-line max-params
  setItem(sKey: string, sValue: string, vEnd?: number | Date, sPath?: string, sDomain?: string, bSecure?: string) {
    if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    let sExpires = '';
    if (vEnd) {
      sExpires = getExpires(vEnd);
    }
    const k = encodeURIComponent(sKey);
    const v = encodeURIComponent(sValue);
    const d = sDomain ? `; domain=${sDomain}` : '';
    const p = sPath ? `; path=${sPath}` : '';
    const s = bSecure ? '; secure' : '';
    document.cookie = `${k}=${v}${sExpires}${d}${p}${s}`;
    return true;
  },

  removeItem(sKey: string, sPath: string, sDomain: string) {
    if (!sKey || !this.hasItem(sKey)) {
      return false;
    }
    const k = encodeURIComponent(sKey);
    const e = '=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    const d = sDomain ? `; domain=${sDomain}` : '';
    const p = sPath ? `; path=${sPath}` : '';
    document.cookie = `${k}${e}${d}${p}`;
    return true;
  },

  hasItem(sKey: string) {
    return new RegExp(`(?:^|;\\s*)${encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&')}\\s*\\=`).test(document.cookie);
  },
};

export default cookies;
